
// Fetches and generates a payment plan hook for all product prices


// const hummMerchantID = '0012600001fHmsFAAS'; // <-- ID used for pre-production env
const hummMerchantID = '0017T00000McyLdQAJ';
const hummWidgetAPIPath = 'https://cas4ujwgul.execute-api.eu-west-1.amazonaws.com/prod/widget';



const makeProductHummHook = (el) => {

  const numberToMoney = (number) => {
    const currencySymbol = document.body.getAttribute('data-currency-symbol');
    //const trailingZeroes = document.body.getAttribute('data-currency-sample').includes('.00');
    number = typeof number === 'string' ? parseFloat(number) : number; // string to float
    //number = trailingZeroes ? number.toFixed(2) : number; // apply decimal point
    number = number.toFixed(2).replace('.00', ''); // format decimal value only where decimal amount exists
    number = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // add thousands commas
    let money = currencySymbol + number; // add currency symbol
    return money;
  }

  // Price parameter needs to have no currency symbol and no commas. Decimal points are valid.
  // E.g. €5,990.49 should be converted to 5990.49
  let price = el.getAttribute('data-product-price');
  price = price.slice(1).replace(',',''); // Remove currency symbol and commas
  
  let term = '0'; // '0' will return all plans for given price
  let url = `${hummWidgetAPIPath}/${hummMerchantID}/${price}/${term}`;
  
  // Fetch data from Humm and apply in callback
  ajaxCall('GET', url, (data) => {

    let plans = JSON.parse(data);

    // If plans are returned for this product price
    if(plans.length) {
      // If 3 plan options, select the middle one, otherwise use last plan by default
      let plan = plans.length == 3 ? plans[1] : plans[plans.length -1];
      // Get frequency unit (e.g. 'month', 'fortnight')
      let planFrequencyUnit = plan.frequency.toLowerCase().includes('monthly') ? 'month' : plan.frequency.toLowerCase().includes('fortnightly') ? 'fortnight' : plan.frequency;
      // Set Humm trigger data
      el.querySelector('.humm_term-frequency').innerText = planFrequencyUnit;
      el.querySelector('.humm_term-amount').innerText = numberToMoney(plan.acctKeepingFee + plan.intFreeAmt);
      el.classList.remove('loading');
    }
    else {
      let thisProductCard = el.closest('.product-card');
      if(thisProductCard) {
        thisProductCard.classList.remove('payment-plan');
      }
    }

  });

} // makeProductHummHook()




// Call for all existing Humm hooks on page
let productPaymentPlanHooks = document.querySelectorAll('.product-payment-plan-hook');
if(productPaymentPlanHooks.length > 0) {
  productPaymentPlanHooks.forEach((hook) => makeProductHummHook(hook));
}